<template>
    <base-dialog :value="dialog" :width="480" :title="$t('routines.replace_routines')" :persistent="persistent"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="rep-body">
            <p class="rep-hint">
                {{ hintTop }}
                {{ hintBottom }}
            </p>
            <div class="rep-list">
                <button v-for="(routine, i) in toReplace" :key="i" type="button" class="rep-row"
                    :class="{ active: routine.replace }" @click="routine.replace = !routine.replace">
                    <span class="rep-name">{{ rowLabel(routine) }}</span>
                    <v-icon size="20" :color="routine.replace ? 'accent' : 'txtMuted'">
                        {{ routine.replace ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                    </v-icon>
                </button>
            </div>
        </div>

        <template v-slot:footer>
            <v-btn block depressed x-large color="primary" class="footer-btn black--text" @click.stop="onConfirm">
                {{ $t('common.confirm') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "SelectReplaceAssignedRoutinesDialog",
    components: { BaseDialog },
    props: {
        assignedRoutinesInSameDate: {
            type: Array,
            default: () => [],
        },
        mode: {
            type: String,
            default: 'students',
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            date: '',
            toReplace: [],
            confirmed: false,
        }
    },
    computed: {
        hintTop(vm = this) {
            return vm.mode === 'dates'
                ? vm.$t('routines.already_have_routine')
                : vm.$t('routines.student_already_have_routine')
        },
        hintBottom(vm = this) {
            return vm.mode === 'dates'
                ? vm.$t('routines.select_dates_to_replace_routine')
                : vm.$t('routines.select_student_to_replace_routine')
        },
    },
    methods: {
        show(date = null) {
            const vm = this
            vm.date = date
            vm.confirmed = false
            vm.dialog = true
        },
        hide() {
            const vm = this
            if (!vm.dialog) return
            vm.dialog = false
            if (!vm.confirmed) vm.$emit('cancel')
        },
        onConfirm() {
            const vm = this
            if (vm.confirmed) return
            vm.confirmed = true
            vm.$emit('confirm', { date: vm.date, toReplace: vm.toReplace })
            vm.hide()
        },
        rowLabel(routine) {
            if (routine.studentName) return routine.studentName
            if (routine.name) return `${routine.name} - ${routine.date}`
            return routine.date
        },
    },
    watch: {
        assignedRoutinesInSameDate(val) {
            const list = [...(val || [])]
            this.toReplace = this.mode === 'students'
                ? list.sort((a, b) => (a.studentName || '').localeCompare(b.studentName || '', undefined, { sensitivity: 'base' }))
                : list
        },
    }
}
</script>

<style scoped>
.rep-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.rep-hint {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--v-txtSecondary-base);
}

.rep-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.rep-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    color: var(--v-txtSecondary-base);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color .15s, background .15s, color .15s;
}

.rep-row.active {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, 0.12);
    color: var(--v-txtPrimary-base);
}

.rep-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
